export default "__VITE_ASSET__CoudPJrs__"